import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NbLayoutModule, NbSidebarModule } from '@nebular/theme';
import { provideNbTheme } from './nebular.providers';
import { HeaderComponent } from './shared/header/header.component';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NbLayoutModule,
    NbSidebarModule,
    HeaderComponent
],
  providers: [provideNbTheme()],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'lamp-poles';
}
